(() => {
  const CARDS_PER_SLIDE = 4;

  const getWishlistHandles = () => {
    try {
      return (localStorage.getItem('shopify-wishlist') || '')
        .split(',')
        .map((handle) => handle.trim())
        .filter(Boolean);
    } catch (error) {
      return [];
    }
  };

  const setWishlistHandles = (handles) => {
    try {
      if (handles.length) localStorage.setItem('shopify-wishlist', handles.join(','));
      else localStorage.removeItem('shopify-wishlist');
      return true;
    } catch (error) {
      return false;
    }
  };

  const syncWishlistButton = (button, handles = getWishlistHandles()) => {
    const handle = button.dataset.productHandle;
    const title = button.dataset.productTitle || 'Product';
    const isActive = Boolean(handle && handles.includes(handle));

    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', String(isActive));
    button.setAttribute('aria-label', `${isActive ? 'Remove' : 'Add'} ${title} ${isActive ? 'from' : 'to'} wishlist`);
  };

  const toggleWishlist = (event, button) => {
    event.preventDefault();
    event.stopPropagation();
    if (button.disabled || !button.dataset.productHandle) return;

    const handle = button.dataset.productHandle;
    const title = button.dataset.productTitle || 'Product';
    const handles = getWishlistHandles();
    const index = handles.indexOf(handle);
    const wasAdded = index === -1;

    if (wasAdded) handles.push(handle);
    else handles.splice(index, 1);
    if (!setWishlistHandles(handles)) return;

    document.querySelectorAll(`[data-mcg-wishlist][data-product-handle="${CSS.escape(handle)}"], [data-rcc-wishlist][data-product-handle="${CSS.escape(handle)}"]`)
      .forEach((item) => syncWishlistButton(item, handles));

    const status = button.closest('.mukhi-collection-grid')?.querySelector('[data-mcg-wishlist-status]');
    if (status) status.textContent = `${title} ${wasAdded ? 'added to' : 'removed from'} your wishlist.`;
    document.dispatchEvent(new CustomEvent('rudraksha:wishlist-updated', { detail: { count: handles.length } }));
  };

  const initWishlist = (scope) => {
    scope.querySelectorAll('[data-mcg-wishlist]').forEach((button) => {
      syncWishlistButton(button);
      if (button.dataset.mcgWishlistReady === 'true') return;
      button.dataset.mcgWishlistReady = 'true';
      button.addEventListener('click', (event) => toggleWishlist(event, button));
    });
  };

  const createSlides = (carousel) => {
    if (carousel.dataset.mukhiCarouselReady === 'true') return;

    const cards = Array.from(carousel.children).filter((element) =>
      element.classList.contains('mukhi-collection-grid__card')
    );
    if (!cards.length) return;

    const slideCount = Math.ceil(cards.length / CARDS_PER_SLIDE);
    const fragment = document.createDocumentFragment();

    for (let index = 0; index < cards.length; index += CARDS_PER_SLIDE) {
      const slide = document.createElement('div');
      const slideNumber = Math.floor(index / CARDS_PER_SLIDE) + 1;

      slide.className = 'mukhi-collection-grid__slide';
      slide.setAttribute('role', 'group');
      slide.setAttribute('aria-roledescription', 'slide');
      slide.setAttribute('aria-label', `${slideNumber} of ${slideCount}`);
      cards.slice(index, index + CARDS_PER_SLIDE).forEach((card) => slide.appendChild(card));
      fragment.appendChild(slide);
    }

    carousel.appendChild(fragment);
    carousel.dataset.mukhiCarouselReady = 'true';
    carousel.classList.add('mukhi-collection-grid__cards--carousel-ready');
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-mukhi-mobile-carousel]').forEach(createSlides);
    initWishlist(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
